import reduxWrapper from 'next-redux-wrapper';
import initStore from "../data/redux";
var withRedux = reduxWrapper(initStore);
export default withRedux;